import React, { Component } from 'react';
import './App.css';
import avengerLogo from './assets/avenger-logo.png'
import avengerAudio from './assets/Avengers_Endgame_-_Trailer_Theme_Piano.mp3'

import {
  FacebookShareButton,
  GooglePlusShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  GooglePlusIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';

const getTimeRemaining = (endtime) => {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

class App extends Component {
  componentDidMount() {
    var myDate="26-04-2019";
    myDate=myDate.split("-");
    var deadline=myDate[1]+","+myDate[0]+","+myDate[2];
    this.initializeClock('clockdiv', deadline);
  }
  
  _getRandomNumber = (imageLength) => {
    return Math.floor(Math.random() * (imageLength + 1));
  }



initializeClock = (id, endtime) => {
  var clock = document.getElementById(id);
  var daysSpan = clock.querySelector('.days');
  var hoursSpan = clock.querySelector('.hours');
  var minutesSpan = clock.querySelector('.minutes');
  var secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    var t = getTimeRemaining(endtime);

    daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}

  render() {
    return (
      <div>
      <audio autoplay="autoplay" loop='loop' src={avengerAudio}></audio>
      <ul className="cb-slideshow">
            <li><span>Image 01</span></li>
            <li><span>Image 02</span></li>
            <li><span>Image 03</span></li>
            <li><span>Image 04</span></li>
            <li><span>Image 05</span></li>
            <li><span>Image 06</span></li>
        </ul>
        <div id="clockdiv">
        <img style={{width: '50vw', maxWidth:'500px', marginBottom: '20px'}} src={avengerLogo} alt="avenger"/>
          <section>
          <div>
              <span class="days"></span>
              <div class="smalltext">Days</div>
            </div>
            <div>
              <span class="hours"></span>
              <div class="smalltext">Hours</div>
            </div>
            <div>
              <span class="minutes"></span>
              <div class="smalltext">Minutes</div>
            </div>
            <div>
              <span class="seconds"></span>
              <div class="smalltext">Seconds</div>
            </div>
          </section>
        </div>
        <div style={{display: 'flex', position:'absolute', bottom: '10px', width: '100vw', justifyContent:'center', alignItems:'center'}}>
        <div style={{padding: '10px'}}>
          <TwitterShareButton url='https://endgame.netlify.com' size={64} round={true}>
            <TwitterIcon size={64} round={true} />
          </TwitterShareButton>
          </div>
          <div style={{padding: '10px'}}>
          <FacebookShareButton url='https://endgame.netlify.com' size={64} round={true}>
            <FacebookIcon size={64} round={true} />
          </FacebookShareButton>
          </div>
          <div style={{padding: '10px'}}>
          <GooglePlusShareButton url='https://endgame.netlify.com' size={64} round={true}>
            <GooglePlusIcon size={64} round={true} />
          </GooglePlusShareButton>
          </div>
          <div style={{padding: '10px'}}>
          <WhatsappShareButton url='https://endgame.netlify.com' size={64} round={true}>
            <WhatsappIcon size={64} round={true} />
          </WhatsappShareButton>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
